module.exports = __webpack_public_path__ + "img/ADMIS.7bf9caa4.png";